import { ClientGlobalSystem } from './ClientBase';

export class FootstepParticleRenderSystem extends ClientGlobalSystem {
  run(deltaTime: number): void {
    this.clientServices.footstepParticle.tick(deltaTime);
  }
}
